import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MapPin } from 'lucide-react';
interface Purchase {
  name: string;
  location: string;
  product: string;
  productTitle: string;
  price: string;
  time: string;
  productImage: string;
}
const purchases: Purchase[] = [
// Digital purchases - LATAM and USA
{
  name: 'Carlos Mendoza',
  location: 'Caracas, Venezuela',
  product: 'Copia Digital',
  productTitle: 'Minerales de Sangre',
  price: '$9.97',
  time: 'Hace 2 min',
  productImage: 'https://cdn.magicpatterns.com/uploads/sqtjrmaovecA2RQi7zLhyq/Digital.png'
}, {
  name: 'John Smith',
  location: 'Miami, USA',
  product: 'Copia Digital',
  productTitle: 'Minerales de Sangre',
  price: '$9.97',
  time: 'Hace 5 min',
  productImage: 'https://cdn.magicpatterns.com/uploads/sqtjrmaovecA2RQi7zLhyq/Digital.png'
}, {
  name: 'María González',
  location: 'Ciudad de México, México',
  product: 'Copia Digital',
  productTitle: 'Minerales de Sangre',
  price: '$9.97',
  time: 'Hace 8 min',
  productImage: 'https://cdn.magicpatterns.com/uploads/sqtjrmaovecA2RQi7zLhyq/Digital.png'
},
// Physical purchases - USA only
{
  name: 'Robert Johnson',
  location: 'New York, USA',
  product: 'Libro Tapa Blanda',
  productTitle: 'Minerales de Sangre',
  price: '$19.97',
  time: 'Hace 12 min',
  productImage: 'https://cdn.magicpatterns.com/uploads/jBdJWzuepheqrCCjGXTU67/ChatGPT_Image_Jan_13,_2026,_12_53_31_PM.png'
}, {
  name: 'Sarah Williams',
  location: 'Los Angeles, USA',
  product: 'Libro Tapa Dura',
  productTitle: 'Minerales de Sangre',
  price: '$34.97',
  time: 'Hace 15 min',
  productImage: 'https://cdn.magicpatterns.com/uploads/5Q6fLogqAjPCjYchUmBKxN/HardCover.png'
}, {
  name: 'José Ramírez',
  location: 'Bogotá, Colombia',
  product: 'Copia Digital',
  productTitle: 'Minerales de Sangre',
  price: '$9.97',
  time: 'Hace 18 min',
  productImage: 'https://cdn.magicpatterns.com/uploads/sqtjrmaovecA2RQi7zLhyq/Digital.png'
}, {
  name: 'Michael Brown',
  location: 'Houston, USA',
  product: 'Premium',
  productTitle: 'Minerales de Sangre',
  price: '$94.97',
  time: 'Hace 22 min',
  productImage: 'https://cdn.magicpatterns.com/uploads/2emtCeZJdgJpsqcSbinmtB/ChatGPT_Image_Jan_14,_2026,_01_04_18_AM.png'
}];
export function SalesPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const showNotification = () => {
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialTimer = setTimeout(showNotification, 3000);
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % purchases.length);
      showNotification();
    }, 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  const currentPurchase = purchases[currentIndex];
  return <AnimatePresence data-id="element-394">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.95
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-0 left-0 right-0 md:bottom-6 md:left-6 md:right-auto z-50 md:max-w-sm" data-id="element-395">
          <div className="bg-white/70 backdrop-blur-2xl md:rounded-2xl rounded-t-2xl shadow-2xl border-t border-white/40 md:border border-white/40 overflow-hidden" data-id="element-396">
            <div className="flex items-start gap-3 p-4" data-id="element-397">
              {/* Product Image */}
              <div className="flex-shrink-0" data-id="element-398">
                <img src={currentPurchase.productImage} alt={currentPurchase.product} className="w-16 h-16 object-cover rounded-lg shadow-sm" data-id="element-399" />
              </div>

              {/* Purchase Details */}
              <div className="flex-1 min-w-0" data-id="element-400">
                <div className="flex items-start justify-between gap-2 mb-1" data-id="element-401">
                  <p className="font-semibold text-gray-900 text-sm" data-id="element-402">
                    {currentPurchase.name}
                  </p>
                  <span className="text-xs text-gray-500 whitespace-nowrap" data-id="element-403">
                    {currentPurchase.time}
                  </span>
                </div>

                <div className="flex items-center gap-1 text-xs text-gray-600 mb-2" data-id="element-404">
                  <MapPin className="w-3 h-3" data-id="element-405" />
                  <span className="truncate" data-id="element-406">{currentPurchase.location}</span>
                </div>

                <p className="text-sm text-gray-700 mb-0.5" data-id="element-407">
                  Compra realizada:{' '}
                  <span className="font-semibold text-gray-900" data-id="element-408">
                    {currentPurchase.price}
                  </span>
                </p>

                <p className="text-xs text-gray-600 italic mb-0.5" data-id="element-409">
                  {currentPurchase.productTitle}
                </p>

                <p className="text-xs text-[#7F1D1D] font-medium" data-id="element-410">
                  {currentPurchase.product}
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}